import React, { useEffect, useState } from "react";
import Banner from "./Banner";
import "../Style/Component/Bannerupdate.css";
import { useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api.js";
import add from "../Assets/Splash/plus.svg";
import { BannerSkeleton } from "./Skeleton.jsx";

const Bannerupdate = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth.permission;
  const [banner, setBanner] = useState([]);
  const [selectedbanner, setSelectedbanner] = useState("driver");
  const [loading, setLoading] = useState(false);
  const fetchbannerdetails = async () => {
    try {
      setLoading(true);
      const response = await getWithTokenAPI(
        token,
        `/banner/app?banner_for=${selectedbanner}`,
      );

      setBanner(response?.data);
    } catch {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchbannerdetails();
  }, [token, selectedbanner]);
  const nextOrder =
    banner.length > 0
      ? Math.max(...banner.map((b) => b.banner_order || 0)) + 1
      : 1;

  const handleAddNew = () => {
    setBanner((prev) => [
      ...prev,
      {
        isNew: true,
        type: selectedbanner,
      },
    ]);
  };

  return (
    <div className="bannerupdate">
      {loading ? (
        <BannerSkeleton />
      ) : (
        <div className="banner">
          <div className="choosebanner">
            <div>
              {/* <span
              className={selectedbanner === "user" ? "selectedspan" : ""}
              onClick={() => setSelectedbanner("user")}
            >
              User
            </span> */}
              <span
                className="selectedspan"
                // onClick={() => setSelectedbanner("driver")}
              >
                Driver
              </span>
            </div>
            {permission?.splash_screen?.create && (
              <button
                type="submit"
                style={{
                  background: "var(--primary)",
                  border: "none",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  color: "white",
                  padding: "5px",
                  width: "fit-content",
                  cursor: "Pointer",
                }}
                onClick={handleAddNew}
              >
                <img src={add} style={{ marginRight: "5px" }}></img>Create One
              </button>
            )}
          </div>
          {selectedbanner === "user" ? (
            <div className="customerbanner">
              {/* <span className="bu">Customer Banner Update</span> */}
              <div className="specificbanner">
                {banner?.map((item, index) => (
                  <Banner
                    key={index}
                    details={item}
                    // onChange={()=>fetchbannerdetails()}
                    isNew={item.isNew}
                    type={"user"}
                    ordercount={item.isNew ? nextOrder : item.banner_order}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className="dealerbanner">
              {/* <span className="bu">Dealer Banner Update</span> */}
              <div className="specificbanner">
                {banner?.map((item, index) => (
                  <Banner
                    key={index}
                    details={item}
                    onChange={() => fetchbannerdetails()}
                    isNew={item.isNew}
                    type={"driver"}
                    ordercount={item.isNew ? nextOrder : item.banner_order}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Bannerupdate;
